<template>
	<div class="modal-backdrop" @click.self="close">
		<div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">

			<section class="modal-body" id="modalDescription">
				<slot name="body">
					Lorem, ipsum dolor sit amet consectetur adipisicing elit. Praesentium adipisci sint est, itaque beatae deserunt ipsum illo doloribus laboriosam molestias maxime facere, consequuntur veniam quod commodi eveniet quam distinctio ipsam.
				</slot>
			</section>

			<footer class="modal-footer">
				<slot name="footer">
					<button-close type="button" :onClick="close" class="xs">Fechar</button-close>
				</slot>
			</footer>
		</div>
	</div>
</template>

<script>
import ButtonClose from './ButtonAction'
export default {
	name: 'Modal',
	components: { ButtonClose },
	methods: {
		close () {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
.modal-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	background-color: #0007;

	.modal {
		background: #fff;
		box-shadow: #3337 1px 1px 10px 1px;
		overflow-x: auto;
		display: flex;
		flex-direction: column;
			width: 500px;

			.modal-footer {
				padding: 20px;
				display: flex;
			}

			.modal-footer {
				justify-content: center;
				width: 100%;

				button {
					width: unset;
					padding: 10px 25px;

					&:not(:last-of-type) {
						margin-right: 10px;
					}
				}
			}

			.modal-body {
				position: relative;
				padding: 30px 10px 20px;
				color: $main-color;
				text-align: center;
				font-size: 1.3em;
			}
		}
	}
	.itens {
		display: flex;
		justify-content: center;
		flex-direction: column;
		padding: 0px 30px;

		.texto {
			margin-bottom: 20px;
			color: #3367d6;
			font-weight: $font-weight-default-bolder;
		}
		.msg {
			font-size: 0.8em;
			margin-top: -10px;
		}
		.item {
			background-color: #f3f7fc;
			border-radius: 5px;
			color: #4f5c6b;
			min-height: 50px;
			display: flex;
			align-items: center;
			padding: 0 11px;
			margin-bottom: 10px;

			label {
				font-weight: $font-weight-default-bolder;
			}

			input {
				width: 100%;
				border: none;
				outline: none;
				font-size: 0.8em;
				background: transparent;

				&::placeholder {
					font-weight: $font-weight-default-bolder;
					color: $main-color;
					font-size: .9em;
				}

				&::-webkit-input-placeholder {
					font-weight: $font-weight-default-bolder;
					color: $main-color;
					font-size: .9em;
				}
			}
		}
	}

.modal-fade-enter,
.modal-fade-leave-active {
	opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity .5s ease
}
</style>
